import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ArrowLeft } from 'lucide-react';

const DEMO_USER = 'admin';
const DEMO_PASS = '123321';

export default function DemoLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === DEMO_USER && password === DEMO_PASS) {
      localStorage.setItem('demo_authenticated', '1');
      navigate('/propuesta/demo/dashboard');
    } else {
      setError(true);
      setTimeout(() => setError(false), 2500);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 px-6">
      <div className="max-w-md w-full">
        <button
          onClick={() => navigate('/propuesta')}
          className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition mb-4"
          data-testid="demo-login-back"
        >
          <ArrowLeft size={15} />
          <span>Volver a la propuesta</span>
        </button>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center">
              <Lock className="text-white" size={28} />
            </div>
          </div>
          
          <h1 className="text-2xl font-bold text-center text-gray-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Demo Sistema de Tasación
          </h1>
          <p className="text-sm text-center text-gray-500 mb-8">
            Acceso exclusivo para Vladimir & Aerocar
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Usuario
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition"
                autoFocus
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Contraseña
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition"
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                Usuario o contraseña incorrectos
              </div>
            )}

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl"
            >
              Acceder al sistema
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-xs text-gray-400">
              Demo · Vladimir & Aerocar 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
